import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledBackgroundWrapper = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.secondaryPaperColor,
	borderRadius: '8px'
}));
